import { Route, Routes } from "react-router-dom";
import BulkUnsubscribe from "./views/BulkUnsubscribe";
import ThankYou from "./views/ThankYou";
import MultiselectUnsubscribe from "./views/MultiselectUnsubscribe";
import NotFound from "./views/NotFound";
import Business from "./views/Business";
import ErrorHandler from "./components/ErrorHandler";
import CommunicationsHub from "./views/CommunicationsHub";
import QueryParameters from "./api/QueryParameters";

const COMMUNICATIONS_HUB: string = "ch";

function V2Route() {
  const queryParams = new QueryParameters();
  if (queryParams.getScr() === COMMUNICATIONS_HUB) {
    return (
      <ErrorHandler>
        <CommunicationsHub />
      </ErrorHandler>
    );
  }
  return (
    <ErrorHandler>
      <BulkUnsubscribe />
    </ErrorHandler>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/v0" element={<Business />} />
      <Route
        path="/v1"
        element={
          <ErrorHandler>
            <MultiselectUnsubscribe />
          </ErrorHandler>
        }
      />
      <Route path="/v2" element={<V2Route />} />
      <Route path="/thankyou" element={<ThankYou />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
